import { useStateMachine } from "little-state-machine"
import { useIntl } from "react-intl"
import { updateAction } from "utils/littleStateMachine"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { VALIDATION_MESSAGES } from "utils/forms"
import InputTextArea from "components/InputMUI/TextArea"
import { GENERIC_MSGS } from "modules/claims/constants"
import { BUTTON_MESSAGES } from "utils/buttons"
import ProgressBar from "modules/claims/components/StepForm/ProgressBar"
import Select from "components/InputMUI/Select"
import { COLOR_FADING_MSGS, PROTECT_PRODUCT_CUSHIONS_OPTIONS } from "./contants"
import { useNavigate } from "react-router-dom"
import { redirectToNextStep } from "../../../utils"

const ColorFading = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const { actions, state } = useStateMachine({ updateAction })

  const defaultValues = { ...state }
  const schema = yup.object({
    cleaningAgentsUsed: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    protectProductCushions: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    surfaceContact: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required))
  })

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema)
  })

  const onSubmit = (data) => {
    actions.updateAction(data)
    redirectToNextStep(navigate)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InputTextArea
        name="cleaningAgentsUsed"
        control={control}
        label={COLOR_FADING_MSGS.cleaningAgentsUsed}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.cleaningAgentsUsed}
        error={errors.cleaningAgentsUsed?.message}
      />
      <Select
        name="protectProductCushions"
        control={control}
        label={COLOR_FADING_MSGS.protectProductCushions}
        placeholder={GENERIC_MSGS.choose_placeholder}
        options={PROTECT_PRODUCT_CUSHIONS_OPTIONS}
        defaultValue={state.protectProductCushions}
        error={errors.protectProductCushions?.message}
      />
      <InputTextArea
        name="surfaceContact"
        control={control}
        label={COLOR_FADING_MSGS.surfaceContact}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.surfaceContact}
        error={errors.surfaceContact?.message}
      />
      <div className="btn-container">
        <button className="btn btn-dark" type="submit">
          {intl.formatMessage(BUTTON_MESSAGES.ok)}
        </button>
      </div>
      <ProgressBar
        progress={60}
        handleNext={handleSubmit(onSubmit)}
        RoutePrev={state.previousStep}
      />
    </form>
  )
}

export default ColorFading
